import { z } from "zod";

import { packagingComponentCartonSchema } from "./packaging-component/packaging-component-carton";
import { packagingComponentLabelSchema } from "./packaging-component/packaging-component-label";
import { locationSchema } from "./location";

export const packagingSolutionSchema = z.object({
	cartons: z.array(packagingComponentCartonSchema),
	labels: z.array(packagingComponentLabelSchema),
	location: locationSchema.optional(),
});

export type PackagingSolution = z.infer<typeof packagingSolutionSchema>;
